import optionsApi from "./optionsApi";

export interface IGrantDocument {
  id?: string;
  s3Url?: string;
  type?: string;
  size?: number;
  isUserUploaded?: boolean;
  /** GRANT_RELATED_DOCUMENT | EMPLOYEE_RELATED_DOCUMENT | GRANT_TRANSACTION_DOCUMENT */
  documentType?: string;
  generatedOn?: string;
  documentName?: string;
  /** optionHolderId (grant ID) */
  entityId?: string;
  /** "GRANT" | "EMPLOYEE" | "TRANSACTION" — used client-side for accordion filtering */
  entityType?: string;
  metaData?: {
    shownToEmployee?: boolean;
    canEmployeeDownload?: boolean;
    tags?: { label: string; value: string }[];
  };
}

/** Fetch all documents related to a grant (system-generated + user-uploaded) */
export const getGrantDocuments = async (
  grantId: string
): Promise<IGrantDocument[]> => {
  const response = await optionsApi.get(`/v1/grant/getGrantDocuments`, {
    params: { grantId },
  });
  return response.data?.data || [];
};

/** Upload a new document against a grant / employee / transaction */
export const uploadGrantDocument = async (payload: {
  entityId: string;
  documentType: string;
  documentName: string;
  b64File: string;
  contentType: string;
  metaData?: {
    shownToEmployee?: boolean;
    canEmployeeDownload?: boolean;
    tags?: { label: string; value: string }[];
    transactionId?: string;
  };
}): Promise<IGrantDocument> => {
  const response = await optionsApi.post(
    `/v1/grant/uploadGrantDocuments`,
    payload
  );
  return response.data?.data;
};

/** Update metadata (name, type, visibility, tags) for an existing grant document */
export const updateGrantDocument = async (payload: {
  id: string;
  documentType?: string;
  documentName?: string;
  metaData?: {
    shownToEmployee?: boolean;
    canEmployeeDownload?: boolean;
    tags?: { label: string; value: string }[];
  };
}): Promise<IGrantDocument> => {
  const response = await optionsApi.post(
    `/v1/grant/updateGrantDocumentMetaData`,
    { data: payload }
  );
  return response.data?.data;
};

/** Delete one or more grant documents by ID */
export const deleteGrantDocuments = async (
  documentIds: string[]
): Promise<void> => {
  await optionsApi.delete(`/v1/grant/deleteGrantDocuments`, {
    data: { documentIds },
  });
};

export interface IGrantTransactionOption {
  id: string;
  transactionType: string;
  transactionDate: string;
  noOfOptions: number;
  eventType?: string;
  label: string;
}

export const getGrantTransactionsForDocument = async (
  grantId: string
): Promise<IGrantTransactionOption[]> => {
  const response = await optionsApi.get(
    `/v1/grant/getGrantTransactionsForDocument/${grantId}`
  );
  return response.data?.data || [];
};
